export default __webpack_public_path__ + "static/media/Question.18df4008.svg";